module.exports = __webpack_public_path__ + "static/media/Hibisco_250.26a1ca62.jpg";